import React, { useState } from 'react';

const STATUT_BADGE = {
  estime: { label: 'estimé', cls: 'rtl-status-estime', title: 'Pattern non vérifié — domaine connu, ordre par fréquence' },
  mx_ok: { label: 'MX', cls: 'rtl-status-mx', title: 'Le serveur mail du domaine répond' },
  smtp_ok: { label: 'SMTP', cls: 'rtl-status-smtp', title: 'Boîte vérifiée via probe SMTP' },
  verifie_dropcontact: { label: '✓', cls: 'rtl-status-verifie', title: 'Vérifié par Dropcontact' },
};

const TEMPLATES = [
  {
    id: 'premier_contact',
    label: '✉️ Premier contact',
    subject: (p) => `Présentation autodom97 — ${p.nom_complet || ''}`,
    body: (p) => `Bonjour ${p.dirigeant_prenom || ''} ${p.dirigeant_nom || ''},\n\n` +
      `Je me permets de vous contacter en tant que dirigeant de ${p.nom_complet || ''}.\n\n` +
      `[Présenter brièvement votre offre]\n\n` +
      `Seriez-vous disponible pour un échange de quelques minutes cette semaine ?\n\n` +
      `Cordialement,\n[Votre nom]\n\n` +
      `— Vos coordonnées proviennent du registre du commerce. ` +
      `Pour ne plus être contacté, répondez « STOP ».`
  },
  {
    id: 'relance',
    label: '🔁 Relance J+7',
    subject: (p) => `Relance — ${p.nom_complet || ''}`,
    body: (p) => `Bonjour ${p.dirigeant_prenom || ''},\n\n` +
      `Je me permets de revenir vers vous suite à mon précédent message.\n\n` +
      `[Rappeler la valeur ajoutée]\n\n` +
      `Avez-vous quelques minutes cette semaine ?\n\n` +
      `Cordialement,\n[Votre nom]`
  },
  {
    id: 'rdv_concession',
    label: '🤝 Demande RDV',
    subject: (p) => `Rendez-vous concession — ${p.nom_complet || ''}`,
    body: (p) => `Bonjour ${p.dirigeant_prenom || ''} ${p.dirigeant_nom || ''},\n\n` +
      `Je vous propose un rendez-vous en concession pour vous présenter [solution].\n\n` +
      `Disponibilités : [proposer 2-3 créneaux]\n\n` +
      `Cordialement,\n[Votre nom]`
  },
];

function copy(text) {
  if (!text) return;
  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(text).catch(() => {});
  } else {
    const ta = document.createElement('textarea');
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch {}
    document.body.removeChild(ta);
  }
}

function ProspectionContactsCell({ prospect, isEnriching, onEnrich, onShowAudit, quotaReached }) {
  const [emailMenuOpen, setEmailMenuOpen] = useState(false);
  const status = prospect.email_principal_status;
  const badge = STATUT_BADGE[status];

  const hasAny = prospect.site_web || prospect.email_principal || prospect.telephone || prospect.linkedin_dirigeant || prospect.linkedin_entreprise;

  if (!hasAny && !prospect.enriched_at) {
    return (
      <button
        type="button"
        className="prospection-btn-enrich"
        disabled={isEnriching || quotaReached}
        onClick={onEnrich}
        title={quotaReached ? 'Quota Google CSE atteint, réessayer demain' : 'Identifier site, email, téléphone, LinkedIn'}
      >
        {isEnriching ? '⏳' : '⚡'} {isEnriching ? 'En cours…' : 'Enrichir'}
      </button>
    );
  }

  const handleMailto = (template) => {
    if (!prospect.email_principal) return;
    const subj = encodeURIComponent(template.subject(prospect));
    const body = encodeURIComponent(template.body(prospect));
    window.location.href = `mailto:${prospect.email_principal}?subject=${subj}&body=${body}`;
    setEmailMenuOpen(false);
  };

  return (
    <div className="prospection-contacts-cell">
      {/* Email */}
      {prospect.email_principal ? (
        <div className="prospection-contact-row" style={{ position: 'relative' }}>
          <button
            type="button"
            className="prospection-contact-btn"
            onClick={() => setEmailMenuOpen(v => !v)}
            title={`${prospect.email_principal}${badge ? ' — ' + badge.title : ''}`}
          >
            ✉️
          </button>
          {badge && <span className={`prospection-email-badge ${badge.cls}`} title={badge.title}>{badge.label}</span>}
          <span className="prospection-contact-text">{prospect.email_principal}</span>
          {emailMenuOpen && (
            <>
              <div className="prospection-menu-overlay" onClick={() => setEmailMenuOpen(false)} />
              <div className="prospection-menu">
                <button type="button" onClick={() => { copy(prospect.email_principal); setEmailMenuOpen(false); }}>📋 Copier l'email</button>
                {TEMPLATES.map(t => (
                  <button type="button" key={t.id} onClick={() => handleMailto(t)}>{t.label}</button>
                ))}
              </div>
            </>
          )}
        </div>
      ) : null}

      {/* Téléphone */}
      {prospect.telephone && (
        <div className="prospection-contact-row">
          <a href={`tel:${prospect.telephone}`} className="prospection-contact-btn" title="Appeler">📞</a>
          <span className="prospection-contact-text">{prospect.telephone}</span>
          <button type="button" className="prospection-contact-mini" onClick={() => copy(prospect.telephone)} title="Copier">📋</button>
        </div>
      )}

      {/* Site web */}
      {prospect.site_web && (
        <div className="prospection-contact-row">
          <a href={prospect.site_web} target="_blank" rel="noopener noreferrer" className="prospection-contact-btn" title="Ouvrir le site">🌐</a>
          <span className="prospection-contact-text prospection-contact-text--small">{(() => { try { return new URL(prospect.site_web).hostname.replace(/^www\./, ''); } catch { return prospect.site_web; } })()}</span>
        </div>
      )}

      {/* LinkedIn dirigeant */}
      {prospect.linkedin_dirigeant && (
        <div className="prospection-contact-row">
          <a href={prospect.linkedin_dirigeant} target="_blank" rel="noopener noreferrer" className="prospection-contact-btn" title="LinkedIn dirigeant">💼</a>
          <span className="prospection-contact-text prospection-contact-text--small">Dirigeant</span>
        </div>
      )}

      {/* LinkedIn entreprise */}
      {prospect.linkedin_entreprise && (
        <div className="prospection-contact-row">
          <a href={prospect.linkedin_entreprise} target="_blank" rel="noopener noreferrer" className="prospection-contact-btn" title="LinkedIn entreprise">🏢</a>
          <span className="prospection-contact-text prospection-contact-text--small">Société</span>
        </div>
      )}

      {/* Ré-enrichir + audit */}
      <div className="prospection-contact-actions">
        <button type="button" className="prospection-contact-mini" disabled={isEnriching || quotaReached} onClick={onEnrich} title="Ré-enrichir">
          {isEnriching ? '⏳' : '🔄'}
        </button>
        {onShowAudit && (
          <button type="button" className="prospection-contact-mini" onClick={onShowAudit} title="Historique enrichissement">🔌</button>
        )}
      </div>
    </div>
  );
}

export default ProspectionContactsCell;
